import type { TourStep } from "../types.ts";
import { WelcomeStep } from "./WelcomeStep.tsx";

/**
 * NUX tour shown to new users on first landing.
 *
 * It is one screen on purpose. The earlier `thread-home`, `filters`,
 * `agenda`, `omnibox`, and `completion` steps anchored to specific UI on
 * the threads home page (filter dropdown, omnibox, etc.) that no longer
 * exists on the calendar landing surface, and the `assistant` step
 * repeated the contact card the assistant already texts the user. What is
 * left is the only thing a new user cannot pick up by using the product:
 * what okthx does, and that it has to be coached.
 */
export const tourSteps: TourStep[] = [
  {
    id: "welcome",
    Component: WelcomeStep,
  },
];
